import { render, staticRenderFns } from "./texting-form-point.vue?vue&type=template&id=8629968c"
import script from "./texting-form-point.vue?vue&type=script&lang=js"
export * from "./texting-form-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports